// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.machine-control-modal-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.machine-control-meta {
  margin: 0;
  font-size: 0.875rem;
  color: var(--sq-text-2);
}

.machine-control-section h3 {
  margin: 0 0 0.5rem;
  font-size: 0.8125rem;
  font-weight: 650;
  color: var(--sq-text-2);
}

.machine-control-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.machine-control-option {
  min-width: 88px;
}

.machine-control-empty {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--sq-text-3);
  font-size: 0.875rem;
  padding: 0.5rem 0;
}`, "",{"version":3,"sources":["webpack://./src/components/maintenance/machineControlModal.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,SAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,WAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AACF","sourcesContent":[".machine-control-modal-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.machine-control-meta {\n  margin: 0;\n  font-size: 0.875rem;\n  color: var(--sq-text-2);\n}\n\n.machine-control-section h3 {\n  margin: 0 0 0.5rem;\n  font-size: 0.8125rem;\n  font-weight: 650;\n  color: var(--sq-text-2);\n}\n\n.machine-control-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.machine-control-option {\n  min-width: 88px;\n}\n\n.machine-control-empty {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--sq-text-3);\n  font-size: 0.875rem;\n  padding: 0.5rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
